import {
  Box,
  Grid,
  Typography,
  Button,
  TextField,
  Paper,
  Select,
  MenuItem,
} from "@mui/material";
import { useEffect, useState } from "react";
import {
  C5_REGISTERS,
  getSetpoints,
  requestSetpoints,
} from "../../utils/controlConfig";
import { ProgressDialog } from "../plungerPage/progressPopup";
import axios from "../../utils/axiosInstance";
import { toast } from "react-toastify";
import { getUIDescription } from "../SiteAdmin/customerGroupDetails/AssigningCustomerGroupDevice";

export const PlungersCard = ({ unitId, data, fetchData }) => {
  const [form, setForm] = useState({
    casingPSIActual: "",
    c5Version: "",
    casingPidSP: "",
    casingPidDeadband: "",
    propValveControl: "3",
    valvePosition: "3",
    minOutput: "",
    maxOutput: "",
    manualSP: "",
    casingInjSplitSP: "",
    casingInjSplitDB: "",
    hiInjSplitOverrideSP: "",
    hiInjSplitOverrideDB: "",
  });
  const [progressOpen, setProgressOpen] = useState(false);
  const [progressSuccess, setProgressSuccess] = useState(false);
  const [progressError, setProgressError] = useState("");

  const handleChange = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const fetchPlungers = async () => {
    if (!unitId) return;
    try {
      if (data) {
        setForm({
          casingPSIActual: parseFloat(data[40509]),
          c5Version: parseFloat(data._40008),
          casingPidSP: parseFloat(data._43792) / 10 ?? "",
          casingPidDeadband: parseFloat(data._43793) / 10 ?? "",
          propValveControl: data._43979 ?? "3",
          valvePosition: data._42403 ?? "3",
          minOutput: parseFloat(data._43984) / 100 ?? "",
          maxOutput: parseFloat(data._43985) / 100 ?? "",
          manualSP: parseFloat(data._44039) / 100 ?? "",
          casingInjSplitSP: parseFloat(data._44115) / 10 ?? "",
          casingInjSplitDB: parseFloat(data._44119) / 10 ?? "",
          hiInjSplitOverrideSP: parseFloat(data._44131) / 10 ?? "",
          hiInjSplitOverrideDB: parseFloat(data._44135) / 10 ?? "",
        });
      }
    } catch (err) {
      console.error("Failed to get plungers:", err);
    }
  };

  useEffect(() => {
    if (unitId) {
      fetchPlungers();
    }
  }, []);

  const validateFields = () => {
    const emptyFields = Object.entries(form).filter(
      ([key, value]) => value === "" || value === null || value === undefined,
    );
    return emptyFields.map(([key]) => key);
  };

  const updatePlgCasing = async () => {
    const missingFields = validateFields();
    if (missingFields.length > 0) {
      toast.error(
        `Please fill in the following fields: ${missingFields.join(", ")}`,
        {
          autoClose: 5000,
        },
      );
      return;
    }
    try {
      const initialResp = await axios.post(
        `${process.env.REACT_APP_API_GATEAWAY}/iot/device_get_by_register/${unitId}`,
        C5_REGISTERS,
      );
      const baseline = {
        time: Number(initialResp.data.data?.time || 0),
        response: initialResp.data.data?.response || {},
      };
      console.log("Initial baseline time", baseline);
      const sp = (label) => parseFloat(form[label]) || 0;
      let cmd = "S";
      cmd += `,${3791},${sp("casingPidSP") * 10}`;
      cmd += `,${3792},${sp("casingPidDeadband") * 10}`;
      setProgressOpen(true);
      setProgressSuccess(false);
      await axios.post(
        `${process.env.REACT_APP_API_GATEAWAY}/iot/control/precision/cmd`,
        {
          unitId,
          cmd,
          UI_Description: `${getUIDescription()}\n Send Command to the controller \nCmd: ${cmd}`,
        },
        {
          headers: {
            id: "anything",
            "Content-Type": "application/json",
          },
        },
      );
      console.log("Sending command:", cmd);
      setTimeout(() => {
        requestSetpoints(
          unitId,
          "P,508,1,3791,1,3792,1",
          baseline,
          setProgressSuccess,
          setProgressError,
          setProgressOpen,
        );
      }, 100);
    } catch (error) {
      console.log("Error to update main compressor PID controls", error);
    }
  };

  const updatePlgPropValve = async () => {
    const missingFields = validateFields();
    if (missingFields.length > 0) {
      toast.error(
        `Please fill in the following fields: ${missingFields.join(", ")}`,
        {
          autoClose: 5000,
        },
      );
      return;
    }
    try {
      const initialResp = await axios.post(
        `${process.env.REACT_APP_API_GATEAWAY}/iot/device_get_by_register/${unitId}`,
        C5_REGISTERS,
      );
      const baseline = {
        time: Number(initialResp.data.data?.time || 0),
        response: initialResp.data.data?.response || {},
      };
      console.log("Initial baseline time", baseline);
      const sp = (label) => parseFloat(form[label]) || 0;
      let cmd = "S";
      cmd += `,${3978},${sp("propValveControl")}`;
      cmd += `,${2402},${sp("valvePosition")}`;
      cmd += `,${3983},${sp("minOutput") * 100}`;
      cmd += `,${3984},${sp("maxOutput") * 100}`;
      cmd += `,${4038},${sp("manualSP") * 100}`;
      setProgressOpen(true);
      setProgressSuccess(false);
      await axios.post(
        `${process.env.REACT_APP_API_GATEAWAY}/iot/control/precision/cmd`,
        {
          unitId,
          cmd,
          UI_Description: `${getUIDescription()}\n Send Command to the controller \nCmd: ${cmd}`,
        },
        {
          headers: {
            id: "anything",
            "Content-Type": "application/json",
          },
        },
      );
      console.log("Sending command:", cmd);
      setTimeout(() => {
        requestSetpoints(
          unitId,
          "P,3978,1,2402,1,3983,1,3984,1,4038,1",
          baseline,
          setProgressSuccess,
          setProgressError,
          setProgressOpen,
        );
      }, 100);
    } catch (error) {
      console.log("Error to update main compressor PID controls", error);
    }
  };

  const updatePlgCasingInj = async () => {
    const missingFields = validateFields();
    if (missingFields.length > 0) {
      toast.error(
        `Please fill in the following fields: ${missingFields.join(", ")}`,
        {
          autoClose: 5000,
        },
      );
      return;
    }
    try {
      const initialResp = await axios.post(
        `${process.env.REACT_APP_API_GATEAWAY}/iot/device_get_by_register/${unitId}`,
        C5_REGISTERS,
      );
      const baseline = {
        time: Number(initialResp.data.data?.time || 0),
        response: initialResp.data.data?.response || {},
      };
      console.log("Initial baseline time", baseline);
      const sp = (label) => parseFloat(form[label]) || 0;
      let cmd = "S";
      cmd += `,${4114},${sp("casingInjSplitSP") * 10}`;
      cmd += `,${4118},${sp("casingInjSplitDB") * 10}`;
      cmd += `,${4130},${sp("hiInjSplitOverrideSP") * 10}`;
      cmd += `,${4134},${sp("hiInjSplitOverrideDB") * 10}`;
      setProgressOpen(true);
      setProgressSuccess(false);
      await axios.post(
        `${process.env.REACT_APP_API_GATEAWAY}/iot/control/precision/cmd`,
        {
          unitId,
          cmd,
          UI_Description: `${getUIDescription()}\n Send Command to the controller \nCmd: ${cmd}`,
        },
        {
          headers: {
            id: "anything",
            "Content-Type": "application/json",
          },
        },
      );
      console.log("Sending command:", cmd);
      setTimeout(() => {
        requestSetpoints(
          unitId,
          "P,4114,1,4118,1,4130,1,4134,1",
          baseline,
          setProgressSuccess,
          setProgressError,
          setProgressOpen,
        );
      }, 100);
    } catch (error) {
      console.log("Error to update main compressor PID controls", error);
    }
  };

  const versionToLetters = (version) => {
    const lowByte = version & 0xFF;
    const highByte = (version >> 8) & 0xFF;
    return String.fromCharCode(lowByte, highByte);
  }

  return (
    <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
      <Paper sx={{ p: 2, bgcolor: "#1e293b", borderRadius: 2, mb: 2 }}>
        <Box sx={{ display: "flex", mb: 2 }}>
          <Typography sx={{ fontSize: 15 }}>C5 Version</Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            gap: 4
          }}
        >
          <TextField
            disabled
            fullWidth
            size="small"
            value={versionToLetters(form.c5Version)}
            sx={{
              input: {
                color: "#fff",
                backgroundColor: "#1f2937",
                fontSize: 13,
              },
            }}
          />
          <Button
            variant="contained"
            color="primary"
            sx={{ fontSize: { xs: "10px", sm: "11px", md: "12px" }}}
            onClick={() =>
              getSetpoints(
                unitId,
                "P,7,1",
                setProgressSuccess,
                setProgressError,
                setProgressOpen,
              )
            }
          >
            Poll
          </Button>
        </Box>
      </Paper>
      <Paper sx={{ p: 2, bgcolor: "#1e293b", borderRadius: 2, mb: 2 }}>
        <Typography sx={{ mb: 2, fontSize: 14 }}>
          Plunger 1 Casing PID SPs
        </Typography>

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            mb: 2,
          }}
        >
          <Typography sx={{ fontSize: 13 }}>Casing PSI Actual</Typography>
          <Typography sx={{ fontSize: 13 }}>{form.casingPSIActual}</Typography>
        </Box>

        <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
          <Button
            variant="contained"
            color="primary"
            sx={{ fontSize: { xs: "10px", sm: "11px", md: "12px" } }}
            fullWidth
            onClick={() =>
              getSetpoints(
                unitId,
                "P,508,1,3791,1,3792,1",
                setProgressSuccess,
                setProgressError,
                setProgressOpen,
              )
            }
          >
            Get Setpoints
          </Button>
          <Button
            variant="contained"
            color="primary"
            sx={{ fontSize: { xs: "10px", sm: "11px", md: "12px" } }}
            fullWidth
            onClick={updatePlgCasing}
          >
            Submit
          </Button>
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 1,
          }}
        >
          <Box sx={{ flex: 1 }}>
            <Typography sx={{ fontSize: 13 }}>Casing PID SP</Typography>
            <TextField
              fullWidth
              size="small"
              value={form.casingPidSP}
              onChange={(e) => handleChange("casingPidSP", e.target.value)}
              sx={{
                mb: 1,
                input: {
                  color: "#fff",
                  backgroundColor: "#1f2937",
                  fontSize: 13,
                },
              }}
            />
          </Box>
          <Box sx={{ flex: 1 }}>
            <Typography sx={{ fontSize: 13 }}>Casing PID DB</Typography>
            <TextField
              fullWidth
              size="small"
              value={form.casingPidDeadband}
              onChange={(e) =>
                handleChange("casingPidDeadband", e.target.value)
              }
              sx={{
                mb: 1,
                input: {
                  color: "#fff",
                  backgroundColor: "#1f2937",
                  fontSize: 13,
                },
              }}
            />
          </Box>
        </Box>
      </Paper>
      <Paper sx={{ p: 2, bgcolor: "#1e293b", borderRadius: 2, mb: 2 }}>
        <Typography sx={{ mb: 2, fontSize: 14 }}>
          Plunger 1 Proportional Valve Controls (A0-04)
        </Typography>
        <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
          <Button
            variant="contained"
            color="primary"
            sx={{ fontSize: { xs: "10px", sm: "11px", md: "12px" } }}
            fullWidth
            onClick={() =>
              getSetpoints(
                unitId,
                "P,3978,1,2402,1,3983,1,3984,1,4038,1",
                setProgressSuccess,
                setProgressError,
                setProgressOpen,
              )
            }
          >
            Get Setpoints
          </Button>
          <Button
            variant="contained"
            color="primary"
            sx={{ fontSize: { xs: "10px", sm: "11px", md: "12px" } }}
            fullWidth
            onClick={updatePlgPropValve}
          >
            Submit
          </Button>
        </Box>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
          <Box sx={{ display: "flex", gap: 1 }}>
            <Box sx={{ flex: 1 }}>
              <Typography sx={{ fontSize: 13 }}>Prop Valve Control</Typography>
              <Select
                fullWidth
                size="small"
                value={form.propValveControl ?? "3"}
                onChange={(e) =>
                  handleChange("propValveControl", e.target.value)
                }
                style={{ fontSize: 13, backgroundColor: "#1f2937" }}
              >
                <MenuItem disabled value="3" style={{ fontSize: 13 }}>
                  Select Option
                </MenuItem>
                <MenuItem value="2" style={{ fontSize: 13 }}>
                  Flow Rate
                </MenuItem>
                <MenuItem value="0" style={{ fontSize: 13 }}>
                  Manual
                </MenuItem>
                <MenuItem value="1" style={{ fontSize: 13 }}>
                  Casing PSI
                </MenuItem>
              </Select>
            </Box>
            <Box sx={{ flex: 1 }}>
              <Typography sx={{ fontSize: 13 }}>Valve Position@4mA</Typography>
              <Select
                fullWidth
                size="small"
                value={form.valvePosition ?? "3"}
                onChange={(e) => handleChange("valvePosition", e.target.value)}
                sx={{ mb: 1 }}
                style={{ fontSize: 13, backgroundColor: "#1f2937" }}
              >
                <MenuItem disabled value="3" style={{ fontSize: 13 }}>
                  Select Option
                </MenuItem>
                <MenuItem value="0" style={{ fontSize: 13 }}>
                  Open
                </MenuItem>
                <MenuItem value="1" style={{ fontSize: 13 }}>
                  Closed
                </MenuItem>
              </Select>
            </Box>
          </Box>
          <Box sx={{ display: "flex", gap: 1 }}>
            <Box sx={{ flex: 1 }}>
              <Typography sx={{ fontSize: 13 }}>Min Output %</Typography>
              <TextField
                size="small"
                value={form.minOutput}
                onChange={(e) => handleChange("minOutput", e.target.value)}
                sx={{
                  mb: 1,
                  input: {
                    color: "#fff",
                    backgroundColor: "#1f2937",
                    fontSize: 13,
                  },
                }}
              />
            </Box>
            <Box sx={{ flex: 1 }}>
              <Typography sx={{ fontSize: 13 }}>Max Output %</Typography>
              <TextField
                size="small"
                value={form.maxOutput}
                onChange={(e) => handleChange("maxOutput", e.target.value)}
                sx={{
                  mb: 1,
                  input: {
                    color: "#fff",
                    backgroundColor: "#1f2937",
                    fontSize: 13,
                  },
                }}
              />
            </Box>
          </Box>
          <Box sx={{ display: "flex", gap: 1 }}>
            <Box>
              <Typography sx={{ fontSize: 13 }}>Manual SP</Typography>
              <TextField
                size="small"
                value={form.manualSP}
                onChange={(e) => handleChange("manualSP", e.target.value)}
                sx={{
                  mb: 1,
                  input: {
                    color: "#fff",
                    backgroundColor: "#1f2937",
                    fontSize: 13,
                  },
                }}
              />
            </Box>
          </Box>
        </Box>
      </Paper>
      <Paper sx={{ p: 2, bgcolor: "#1e293b", borderRadius: 2 }}>
        <Typography sx={{ mb: 2, fontSize: 14 }}>
          Plunger 1 Casing Injection Split Setpoints
        </Typography>
        <Box sx={{ display: "flex", gap: 1, my: 1 }}>
          <Button
            variant="contained"
            color="primary"
            sx={{ fontSize: { xs: "10px", sm: "11px", md: "12px" } }}
            fullWidth
            onClick={() =>
              getSetpoints(
                unitId,
                "P,4114,1,4118,1,4130,1,4134,1",
                setProgressSuccess,
                setProgressError,
                setProgressOpen,
              )
            }
          >
            Get Setpoints
          </Button>
          <Button
            variant="contained"
            color="primary"
            sx={{ fontSize: { xs: "10px", sm: "11px", md: "12px" } }}
            fullWidth
            onClick={updatePlgCasingInj}
          >
            Submit
          </Button>
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 1,
          }}
        >
          <Box sx={{ flex: 1 }}>
            <Typography sx={{ fontSize: 13 }}>Casing Inj Split SP</Typography>
            <TextField
              fullWidth
              size="small"
              value={form.casingInjSplitSP}
              onChange={(e) => handleChange("casingInjSplitSP", e.target.value)}
              sx={{
                mb: 1,
                input: {
                  color: "#fff",
                  backgroundColor: "#1f2937",
                  fontSize: 13,
                },
              }}
            />
          </Box>
          <Box sx={{ flex: 1 }}>
            <Typography sx={{ fontSize: 13 }}>Casing Inj Split DB</Typography>
            <TextField
              fullWidth
              size="small"
              value={form.casingInjSplitDB}
              onChange={(e) => handleChange("casingInjSplitDB", e.target.value)}
              sx={{
                mb: 1,
                input: {
                  color: "#fff",
                  backgroundColor: "#1f2937",
                  fontSize: 13,
                },
              }}
            />
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 1,
          }}
        >
          <Box sx={{ flex: 1 }}>
            <Typography sx={{ fontSize: 13 }}>
              HI Inj Split Override SP
            </Typography>
            <TextField
              fullWidth
              size="small"
              value={form.hiInjSplitOverrideSP}
              onChange={(e) =>
                handleChange("hiInjSplitOverrideSP", e.target.value)
              }
              sx={{
                mb: 1,
                input: {
                  color: "#fff",
                  backgroundColor: "#1f2937",
                  fontSize: 13,
                },
              }}
            />
          </Box>
          <Box sx={{ flex: 1 }}>
            <Typography sx={{ fontSize: 13 }}>
              HI Inj Split Override DB
            </Typography>
            <TextField
              fullWidth
              size="small"
              value={form.hiInjSplitOverrideDB}
              onChange={(e) =>
                handleChange("hiInjSplitOverrideDB", e.target.value)
              }
              sx={{
                mb: 1,
                input: {
                  color: "#fff",
                  backgroundColor: "#1f2937",
                  fontSize: 13,
                },
              }}
            />
          </Box>
        </Box>
      </Paper>
      <ProgressDialog
        open={progressOpen}
        isSuccess={progressSuccess}
        errorMessage={progressError}
        onClose={() => {
          setProgressOpen(false);
          setProgressError("");
        }}
        onRefresh={async () => {
          setProgressOpen(false);
          setProgressError("");
          await fetchData();
        }}
        loadingMessage="Check Device Response. Operation in-progress ..."
        successMessage="Successfully updated!"
      />
    </Grid>
  );
};
